// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_BuscaFranquiaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /franquias/buscaFranquia/{id}
 *
 * Single FranquiaOutput from the upstream Go franchises-service.
 * dados is a typed object with a Franquia sub-object (scalar fields)
 * and an AreasAtuacao dynamic map.
 */
import type { Franquias_BuscaFranquiaRow } from './Franquias_BuscaFranquiaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Franquias_BuscaFranquiaResponseDados = Franquias_BuscaFranquiaRow;

export type Franquias_BuscaFranquiaResponse = ApiResponse<Franquias_BuscaFranquiaResponseDados>;

registerResponseContract('Franquias_BuscaFranquiaResponse', {
  _nullable:    { type: 'boolean', required: false },
  Franquia: {
    type: 'object',
    required: false,
    fields: {
      ID:        { type: 'number',  required: false },
      Nome:      { type: 'string',  required: false },
      Email:     { type: 'string',  required: false },
      CNPJ:      { type: 'string',  required: false },
      Pais:      { type: 'string',  required: false },
      Idioma:    { type: 'string',  required: false },
      CreatedAt: { type: 'string',  required: false },
      UpdatedAt: { type: 'string',  required: false },
      DeletedAt: { type: 'string',  required: false },
      Ativo:     { type: 'boolean', required: false },
    },
  },
  AreasAtuacao: { type: 'object',  required: true },
})
